export const mapboxToken =
  process.env.MAPBOX_TOKEN_REPRESENTATIVE_SEARCH || process.env.MAPBOX_TOKEN;
